import React, {useState} from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import { motion } from 'framer-motion'

import logoDesign from '../../assets/logoDesign.png'
import dotDesign from '../../assets/dotDesign.png'
import thumbPerson from '../../assets/thumbPerson.png'
import html from '../../assets/html.png'
import mern from '../../assets/mern.png'
import react from '../../assets/react.png'

const containerVariants = {
    initial: {
        x: '-100vw',
        opacity: 0,
    },
    animate: {
        opacity: 1,
        x: 0,
        transition: {
            type: 'spring'
        }
    },
    exit: {
        x: '50vw',
        opacity: 0,
        transition: {
            duration: 0.5
        }
    }
}


const Home = () => {
    return (
        <motion.section className="position-relative" id="home"
            variants={containerVariants}
            initial="initial"
            animate="animate"
            exit="exit"
        >
            <div className="overlay_color"></div>
            <Row className="take-full-screen">
                <Col className="position-relative" xs={12} lg={6}>
                    <div className="position-absolute logo-design-img">
                        <img
                            src={logoDesign}
                            width={160}
                            height='auto'
                        />
                    </div>
                    <div className="position-absolute dot-design-img">
                        <img
                            src={dotDesign}
                            width={160}
                            height='auto'
                        />
                    </div>
                    <Container>
                        <motion.div className="home-post"
                            initial={{
                                x: '-100vw'
                            }}
                            animate={{
                                x: 0
                            }}
                            transition={{
                                type: 'spring',
                                ease: 'easeIn'
                            }}
                        >MERN WEB AND FLUTTER DEVELOPER</motion.div>
                        <div className="font-poppins home-heading">
                            Talk is cheap. <br/>Show me the code.
                        </div>
                        <div className="font-poppins text-left home-my-info">
                            I am <span style={{fontSize: 22, fontWeight: 'bold'}}>Vishal Tiwari</span>, an Intermediate Developer who started coding 5 years ago during my School. I can say I have come a long way when I look back to me 5 years back but there is always more to learn.

                        </div>
                    </Container>
                </Col>
                <Col className="position-relative d-none d-lg-block" xs={12} lg={6}>
                    <div className="position-absolute person-design-img">
                        <img
                            src={thumbPerson}
                            width='auto'
                        />
                    </div>
                    <motion.div className="position-absolute mern-design-img"
                        initial={{
                            y: -20
                        }}
                        animate={{
                            y: 0
                        }}
                        transition={{
                            yoyo: Infinity,
                            ease: 'easeInOut',
                            duration: 1
                        }}
                    >
                        <img
                            src={mern}
                            width={160}
                            height='auto'
                        />
                    </motion.div>
                    <motion.div className="position-absolute html-design-img"
                        initial={{
                            y: -25
                        }}
                        animate={{
                            y: 0
                        }}
                        transition={{
                            yoyo: Infinity,
                            ease: 'easeInOut',
                            duration: 1.5
                        }}
                    >
                        <img
                            src={html}
                            width={160}
                            height='auto'
                        />
                    </motion.div>
                    <motion.div className="position-absolute react-design-img"
                        initial={{
                            rotateZ: 0
                        }}
                        animate={{
                            rotateZ: 360
                        }}
                        transition={{
                            duration: 3,
                            yoyo: Infinity,
                            ease: 'easeInOut'
                        }}
                    >
                        <img
                            src={react}
                            width={60}
                            height='auto'
                        />
                    </motion.div>
                    <Container>
                        <div>
                            Hi
                        </div>
                    </Container>
                </Col>
            </Row>
        </motion.section>
    )
}

export default Home;